export default [
  {
    path: '/main/reportstockinventory',
    meta: {
      tag: 'report_stock_inventory',
      name: 'Inventário de Estoque',
      breadcrumb: 'Inventário de Estoque'
    },
    component: () => import(/* webpackChunkName: "report-stock-inventory" */ '@/views/main/reports/stockinventory/Index.vue'),
    children: [
      {
        path: '',
        name: 'listtrackers',
        meta: {
          tag: 'report_stock_inventory',
          name: 'Inventário de Estoque',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-stock-inventory" */ '@/views/main/reports/stockinventory/List.vue'),
      }
    ]
  }
]